import {Component, Input, OnInit} from "@angular/core";
import {DbResponse} from "../../../../../../shared/interceptors/db-response";
import {HostingService} from "../../../hosting.service";
import * as fromStore from "../../../../../../store";
import {WebsiteService} from "../../../../../website.service";
import {DbStoreState} from "../../../../../../store/reducers";
import {Store} from '@ngrx/store';
import {ActivityAction, ActivityStatus, IActivity} from "../../../../../../activities/activity";
import {Observable} from "rxjs";
import {Website} from "../../../../website";
import {FormControl, Validators} from "@angular/forms";
import {DbServerErrors} from "../../../../../../shared/interceptors/db-server-errors";
import {DbValidators} from "../../../../../../shared/validators/DbValidators";
import {UserSubscription, UserSubscriptionType} from "../../../../../../user/user-subscription";
import {DbActiveModal} from "../../../../../../modules/modal/modal-ref";
import {filter, first} from "rxjs/operators";

@Component({
    selector: 'db-disconnect-website-make-primary-dialog',
    templateUrl: './disconnect-website-make-primary-dialog.component.html',
    styleUrls: ['./disconnect-website-make-primary-dialog.component.scss'],
    standalone: false
})
export class DisconnectWebsiteAndMakeDialogComponent implements OnInit {

  @Input() companyName: string;
  @Input() websiteId: any;
  @Input() currentWebsiteId: any;
  @Input() domainNameId: any;
  @Input() passwordMessage: string;
  @Input() message: any;
  @Input() website: Website;
  @Input() currentSubscription: UserSubscription;
  public loading: boolean;
  public ongoingActivity$: Observable<IActivity[]>;
  public removeWebsiteForm: FormControl;
  public serverErrors: DbServerErrors;
  public UserSubscriptionType: any = UserSubscriptionType;

  constructor(
    private _websiteService: WebsiteService,
    private _store: Store<DbStoreState>,
    private _hostingService: HostingService,
    public activeModal: DbActiveModal
  ) {
  }

  ngOnInit() {
    if (!this.website.parentId && this.currentSubscription.type !== UserSubscriptionType.FREE) {
      this.removeWebsiteForm = new FormControl('', [Validators.required, DbValidators.trim]);
    } else {
      this.removeWebsiteForm = new FormControl('', [Validators.required, DbValidators.trim, Validators.pattern(/(?:^|\W)^REMOVE$(?:$|\W)/)]);
    }
    this.ongoingActivity$ = this._store.select(fromStore.getOngoingActivities);
    this.ongoingActivity$
      .subscribe((ongoingActivities): void => {
        const ongoingRemoveActivities = ongoingActivities.find((activity): boolean => activity.status === ActivityStatus.DONE && activity.action === ActivityAction.REMOVE_WEBSITE);
        if (ongoingRemoveActivities) {
          this.makeDomainPrimary(this.currentWebsiteId, this.domainNameId);
        }
      });
  }


  public confirm(): void {
    this.removeWebsite();
  }

  public removeWebsite(): void {
    this.loading = true;
    if (this.removeWebsiteForm.valid) {
      this._websiteService.removeWebsite(this.websiteId, this.removeWebsiteForm.value)
        .pipe(
          filter((response: DbResponse): boolean => !!response),
          first()
        ).subscribe((response: DbResponse): void => {
          if (!response.success) {
            this.loading = false;
            this.serverErrors = response.serverErrors;
          }
        });
    }
  }

  private makeDomainPrimary(websiteId, domainId) {
    this._hostingService.makeDomainPrimary(websiteId, domainId)
      .pipe(
        filter((response: DbResponse): boolean => !!response),
        first()
      ).subscribe((response: DbResponse): void => {
      if (response.success) {
        this.activeModal.close({success: true});
      }
      this.loading = false;
      this.activeModal.close();
    });
  }


}
